// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { VNumberInput } from 'vuetify/labs/VNumberInput'

// Vuetify
import {createVuetify} from 'vuetify'

const myCustomLightTheme = {
    dark: false,
    colors: {
        background: '#364c5b',
        surface: '#364c5b',
        'surface-light': '#597181',
        primary: '#ffffff',
        'primary-darken-1': '#c0c0c0',
        secondary: '#364c5b',
        'secondary-darken-1': '#018786',
        error: '#ffffff',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
    }
}

export default createVuetify({
    // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
    components: {
        VNumberInput,
    },
    theme: {
        defaultTheme: 'myCustomLightTheme',
        themes: {
            myCustomLightTheme,
        }
    }
})
